import InfoIcon from '@/assets/icons/icon-info.svg'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { IconButton } from '@/modules/chatting/ui/components/icon-button'

interface SharedFollowListCreatorsPopoverProps {
  creators: string[]
}

export const SharedFollowListCreatorsPopover = ({
  creators,
}: SharedFollowListCreatorsPopoverProps) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <IconButton
          icon={InfoIcon}
          className="text-text-default"
        />
      </PopoverTrigger>
      <PopoverContent className="max-h-[300px] w-fit overflow-y-auto">
        <ul className="flex list-disc flex-col gap-2 px-4">
          {creators?.map((name) => <li key={name}>{name}</li>)}
        </ul>
      </PopoverContent>
    </Popover>
  )
}
